const AuthMiddleware = {
  /** ユーザがログイン済みかどうかを判定する */
  isLoggedIn: function() {
    const token = getAccessToken()
    return !!token
  },
  /** ログイン状態にする */
  login: function(token) {
    setAccessToken(token)
  },
  /** ログアウト状態にする */
  logout: function() {
    removeAccessToken()
  },
}

function getAccessToken() {
  return localStorage.getItem('token')
}

function setAccessToken(token) {
  localStorage.setItem('token', token)
}

function removeAccessToken() {
  localStorage.removeItem('token')
}

export default AuthMiddleware
